import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import { TablePlugin, FormSelectPlugin, ButtonPlugin, ModalPlugin, FormInputPlugin, BootstrapVueIcons, ToastPlugin, PaginationPlugin, FormTextareaPlugin, FormFilePlugin } from 'bootstrap-vue';
import loading from 'vuejs-loading-screen'

import VueParticles from 'vue-particles';
Vue.use(VueParticles);
Vue.use(TablePlugin);
Vue.use(FormSelectPlugin);
Vue.use(BootstrapVueIcons);
Vue.use(ToastPlugin);
Vue.use(ButtonPlugin);
Vue.use(ModalPlugin);
Vue.use(FormInputPlugin);
Vue.use(PaginationPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormFilePlugin);
Vue.use(loading, {
    bg: '#d3d3d39e',
    icon: 'refresh',
    size: 3,
    icon_color: 'white',
});

Vue.config.productionTip = false
Vue.prototype.$paginationPages = Object.freeze([
	{ value: 20, text: 20 },
    { value: 50, text: 50 },
    { value: 100, text: 100 }
]);
Vue.prototype.$perPage = 20;
Vue.prototype.$currency = "đ";
// Importing the global css file
import "./assets/font-awesome/font-awesome.min.css"
import "./assets/global.css"
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/theme/custom.css'

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
